<template>
  <CDropdown nav placement="bottom-end">
    <template #toggler>
      <CHeaderNavLink class="ml-2">
        <div class="c-avatar">
          <img src="/img/default-avatar.jpg" class="c-avatar-img" />
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Configuración</strong>
    </CDropdownHeader>
    <CDropdownItem>
      <span
        class="mr-1 badge badge-secondary"
        v-for="role in user.roles"
        :key="role.id"
      >
        {{ role.alias }}
      </span>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-user" /> {{ user.username }}
    </CDropdownItem>
    <CDropdownDivider />
    <CDropdownItem @click="tMenu" to="/usuarios/account">
      <CIcon name="cil-cog" /> Cuenta
    </CDropdownItem>
    <CDropdownItem @click="tMenu" to="/usuarios/password">
      <CIcon name="cil-lock-locked" /> Contraseña
    </CDropdownItem>
    <CDropdownItem @click="logout">
      <CIcon name="cil-account-logout" /> Salir
    </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "TheHeaderDropdownAccnt",
  props: ["toggleMenu"],
  computed: {
    user() {
      return this.$store.state.userAuth;
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch("logout");
      this.$store.commit("set", ["flashAlert", []]);
      this.$router.replace("/ingresar");
    },
    tMenu() {
      this.toggleMenu();
    },
  },
};
</script>

<style lang="scss" scoped>
.c-icon {
  margin-right: 0.3rem;
}
.c-avatar {
  /* position: relative; */
  display: inline-block;
  /* align-items: center; */
  /* justify-content: center; */
  border-radius: 50em;
  width: 30px;
  height: 30px;
  /* font-size: 14.4px; */
  margin: auto;
  line-height: 2.5;
}
</style>
